import axios from 'axios';
import { ProfileUser } from '@ordermentum/ui-types';
import client from './http_client';
import { strToArray } from './string';
import Auth from './auth_client';
import Cart from './cart_client';
import { safeRedirect } from '../helpers/urls';

export * from './creditCardUtils';
export * from './date';
export * from './marketplaces_endpoint_v2';
export * from './pagination';
export * from './string';
export * from './input_modifiers';
export * from './browserUtils';
export * from './fileUtils';
export * from './fp';
export * from './levenshtein';
export * as Sentry from './sentry';
export default client;

export const copyText = (target: string) => {
  const dummy = document.createElement('input');
  document.body.appendChild(dummy);
  dummy.value = target;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);
};

export const signOut = async () => {
  try {
    await axios({
      url: '/session',
      method: 'DELETE',
    });

    window.location.href = safeRedirect('/signin');
  } catch (err) {
    throw new Error('Could not logout');
  }
};

export const normalizeState = (state: string): string => {
  const newState = state.toUpperCase().replace(/ /g, '-');
  if (newState === 'WA' || newState === 'WESTERN-AUSTRALIA') return 'WA';
  if (newState === 'VIC' || newState === 'VICTORIA') return 'VIC';
  if (newState === 'NSW' || newState === 'NEW-SOUTH-WALES') return 'NSW';
  if (newState === 'QLD' || newState === 'QUEENSLAND') return 'QLD';
  if (newState === 'SA' || newState === 'SOUTH-AUSTRALIA') return 'SA';
  if (newState === 'ACT' || newState === 'AUSTRALIAN-CAPITAL-TERRITORY')
    return 'ACT';
  if (newState === 'NT' || newState === 'NORTHERN-TERRITORY') return 'NT';
  if (newState === 'TAS' || newState === 'TASMANIA') return 'TAS';
  return '';
};

export const ensureArray = raw => {
  // eg. to handle legacy flags rval '123,234,345'
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') return strToArray(raw);
  return [];
};

export const storeAccessToken = (token: string, profile?: ProfileUser) => {
  if (!token?.length) return;
  const tokenString = token.includes('Bearer') ? token?.split(' ')?.[1] : token;
  const authorizationHeader = `Bearer ${tokenString}`;
  axios.defaults.headers.common.Authorization = authorizationHeader;
  client.setToken(authorizationHeader);
  Auth.init(authorizationHeader, profile);
  Cart.init(tokenString);
};
